"use client";
import React from "react";
import "./Loader.css";
import preloader from "./../../vid_img/preloader.gif"
const Loader = () => {
  return (
    <div className="loader-wrapper">
      <img src={preloader} alt="language loader" />
    </div>
  );
};

export default Loader;
